/**
 * StreamStatusOutputDTO entity class
 */

/**
 * StreamStatusOutputDTOFactory
 * returns StreamStatusOutputDTO entity class
 *
 * @class StreamStatusOutputDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamStatusOutputDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamStatusOutputDTOFactory
 */
/* @ngInject */
export default function StreamStatusOutputDTOFactory (Entity) {
  /* === StreamStatusOutputDTO class === */

  /**
   * StreamStatusOutputDTO model
   *
   * @class StreamStatusOutputDTO
   * @classdesc StreamStatusOutputDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamStatusOutputDTO entity fields
   * @return {models.StreamStatusOutputDTO} StreamStatusOutputDTO entity
   */
  function StreamStatusOutputDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamStatusOutputDTO.prototype = Object.create(Entity.prototype)
  StreamStatusOutputDTO.prototype.constructor = StreamStatusOutputDTO

  /* === StreamStatusOutputDTO instance methods & fields === */

  Object.assign(StreamStatusOutputDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamStatusOutputDTO#
     * @type {Object}
     */
    _fields: {
      externalId: String,
      profileStatuses: ['StreamStatusOutputProfileDTO']
    }
  })

  /**/

  /* === StreamStatusOutputDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamStatusOutputDTO, Entity)
  StreamStatusOutputDTO._name = 'StreamStatusOutputDTO'
  StreamStatusOutputDTO.init()

  return StreamStatusOutputDTO
}
